import types from '../types';
import api from 'api';
import {useGetApiDispatch} from 'common/hooks/useGetApiDispatch';
import {IDiplomatConnectionResponse} from 'types/diplomat/DiplomatConnection';

export const useConnections = () =>
   useGetApiDispatch<IDiplomatConnectionResponse[]>([], api.connections, types.GET_CONNECTIONS);
